import VueRouter from 'vue-router';
import Home from '@authoringPlatform/pages/Home';
import HelpAndSupport from '@authoringPlatform/pages/HelpAndSupport';
import Dashboard from '@authoringPlatform/pages/Dashboard';
import NewVersion from '@authoringPlatform/pages/NewVersion';
import Edit from '@authoringPlatform/pages/Edit';
import Gadgets from '@authoringPlatform/pages/Edit/pages/Gadgets';
import Scenario from '@authoringPlatform/pages/Edit/pages/Scenario';
import Characters from '@authoringPlatform/pages/Edit/pages/Contacts';
import Outline from '@authoringPlatform/pages/Edit/pages/Outline';
import Administration from '@authoringPlatform/pages/Edit/pages/Administration';
import SignUp from '@authoringPlatform/pages/SignUp';
import ForgotPassword from '@authoringPlatform/pages/ForgotPassword';
import ResetPassword from '@authoringPlatform/pages/ResetPassword';
import MyAccount from '@authoringPlatform/pages/MyAccount';
import Scoring from '@authoringPlatform/pages/Edit/pages/Scoring';
import AllContent from '@authoringPlatform/pages/Edit/pages/AllContent';
import Results from '@authoringPlatform/pages/Dashboard/Results';
import AllResults from '@authoringPlatform/pages/Dashboard/Results/pages/AllVersions';
import ParticipantResults from '@authoringPlatform/pages/Dashboard/Results/pages/SingleVersion';

import { store } from './main';

export const routes = [
  { name: 'home', path: '/', component: Home },
  { name: 'sign-up', path: '/sign-up', component: SignUp },
  { name: 'forgot-password', path: '/forgot-password', component: ForgotPassword },
  {
    name: 'my-account',
    path: '/my-account',
    component: MyAccount,
  },
  {
    name: 'reset-password',
    path: '/reset-password',
    component: ResetPassword,
  },
  {
    name: 'HelpAndSupport',
    path: '/support',
    component: HelpAndSupport,
  },
  {
    name: 'new-version',
    path: '/new-version',
    component: NewVersion,
  },
  {
    name: 'list-versions',
    path: '/dashboard',
    component: Dashboard,
  },
  {
    name: 'projects',
    path: '/projects',
    component: Dashboard,
  },
  {
    name: 'results-page',
    path: '/results',
    component: Results,
    meta: { name: 'Results' },
    children: [
      {
        name: 'results',
        path: '/',
        component: AllResults,
        meta: { name: 'Results' },
      },
      {
        name: 'participant-results',
        path: ':resourceKey/participant-results',
        component: ParticipantResults,
        meta: { name: 'Participant Results' },
      },
    ]
  },
  {
    name: 'edit-version',
    path: '/edit',
    component: Edit,
    children: [
      {
        name: 'skills',
        path: ':resourceKey/skills',
        component: () => import(`@authoringPlatform/pages/Edit/pages/Skills`),
        meta: { name: 'Skills' },
      },
      {
        name: 'scenario',
        path: ':resourceKey/scenario',
        component: Scenario,
        meta: { name: 'Scenario' },
      },
      {
        name: 'administration',
        path: ':resourceKey/administration',
        component: Administration,
        meta: { name: 'Administration' },
      },
      {
        name: 'inbox',
        path: ':resourceKey/inbox',
        component: () => import(`@authoringPlatform/pages/Edit/pages/Inbox`),
        meta: { name: 'Inbox' },
      },
      {
        name: 'characters',
        path: ':resourceKey/characters',
        component: Characters,
        meta: { name: 'Characters' },
      },
      {
        name: 'drive',
        path: ':resourceKey/drive',
        component: () => import(`@authoringPlatform/pages/Edit/pages/Drive`),
        meta: { name: 'Drive' },
      },
      {
        name: 'gadgets',
        path: ':resourceKey/gadgets',
        component: Gadgets,
        meta: { name: 'Gadgets' },
      },
      {
        name: 'outline',
        path: ':resourceKey/outline-report',
        component: Outline,
        meta: { name: 'Outline Report' },
      },
      {
        name: 'scoring',
        path: ':resourceKey/scoring-report',
        component: Scoring,
        meta: { name: 'Scoring Report' },
      },
      {
        name: 'content',
        path: ':resourceKey/all-content',
        component: AllContent,
        meta: { name: 'All Content' },
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/capsiminbox/authoring-platform/',
  linkActiveClass: '',
  linkExactActiveClass: 'active',
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (to.hash) resolve({ selector: to.hash });
        else if (savedPosition) resolve(savedPosition);
        else resolve({ x: 0, y: 0 });
      }, 500);
    });
  },
});

router.beforeEach(function (to, from, next) {
  if (to.meta.protected && !store.state.user.authenticated) next({ name: 'home' });
  else next();
});

//Interceptor for jquery.ajax
$(document).ajaxError((_, xhr, req) => {
  if (/401|403/.test(xhr.status) && !req.url.includes('login')) {
    if (window.onbeforeunload) window.onbeforeunload = null;
    window.location = '/capsiminbox/authoring-platform?invalidSession=true';
  }
});

export default router;
